import React, { useCallback, useContext, useState } from 'react';
import { Card, Form } from 'react-bootstrap';

import type { DirectoryCategoryInfo } from '@components/DirectoryCard/types';
import type { SelectedSupplier } from '@components/Supplier/AddSupplier';
import SupplierSearch from '@components/SupplierSearch';

import scss from './ReviewList.module.scss';

import { BulkReviewsContext, type BulkReviewsContextType } from '../context';
import { parseNumeric } from '@helper/numberHelper';

const CategoryCustom = () => {
    const { categoryInfo, addEmptyReview } = useContext<BulkReviewsContextType>(BulkReviewsContext);
    const [category, setCategory] = useState<DirectoryCategoryInfo | undefined>();

    const handleSelectChange = useCallback((e: React.ChangeEvent<HTMLSelectElement>) => {
        const catId = parseNumeric(e.target.value);
        const cat = categoryInfo?.categories?.find(c => c.categoryId === catId);
        setCategory(cat);
    }, []);

    const handleSaveSupplier = useCallback((supplier: SelectedSupplier | null) => {
        if (!!supplier && !!category && !!addEmptyReview) {
            const supplierId = parseNumeric(supplier.Id);
            !!supplierId && addEmptyReview(supplierId, supplier.Name, category, true);
            setCategory(undefined);
        }
    }, [category]);

    return (
        <Card className={'mb-3'} data-testid="customCategory">
            <Card.Body>
                <div className={scss.compressedContainer}>
                    <div className={scss.compressedItemLeft}>
                        <Form.Select className={scss.categorySelect} onChange={handleSelectChange} value={!!category ? category.categoryId : ''} data-testid="customCategorySelect">
                            <option value={''}>Choose a category</option>
                            {categoryInfo?.categories?.map((cat, ind) => <option key={`cat-${ind}`} value={cat.categoryId}>{cat.name}</option>)}
                        </Form.Select>
                    </div>
                    <div className={scss.compressedItemRight}>
                        <SupplierSearch
                            key={!!category ? `cat-${category.dashboardCategoryId}` : 'cat-0'}
                            categoryName={!!category ? category.name : ''}
                            categorySlug={!!category ? category.slug : ''}
                            placeholder={"Type in supplier's name"}
                            hideBackground={true}
                            isFocus={false}
                            disabled={!category}
                            handleSaveSupplier={handleSaveSupplier}
                        />
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default CategoryCustom
